import React from 'react';
import { methodNameEnum } from '../../../recoil/selectors/makePHPRequest';
import { Formik } from 'formik';
import { ModalWithStyles } from './ModalWithStyles';
import { endpointEnum } from '../../../services/rest/makeAPIRequest';
import { useMutation } from 'react-query';
import { getApiMutation } from '../../../services/rest/getApiMutation';

export function DeleteTeamModal({
  setRefetchToggleForBusinessTeams,
  enqueueSnackbarWithStyles,
  selected,
  handleClose,
  show,
  userAtom,
  setUserAtom,
}) {
  const mutation = useMutation(getApiMutation(userAtom.contents, setUserAtom));
  return (
    <Formik
      onSubmit={async (values, actions) => {
        if (values.selected.length) {
          for (let i = 0; i < values.selected.length; i++) {
            const data = {
              call: methodNameEnum.DELETE_TEAM,
              apikey: userAtom.contents.apikey,
              businessid: userAtom.contents.businessid,
              teamid: values.selected[i].teamid,
            };
            const response = await mutation.mutateAsync({
              endpoint: endpointEnum.DELETE_TEAM,
              payload: data,
            });
            if (!response?.data?.success) {
              enqueueSnackbarWithStyles({
                message:
                  'Looks like we encountered an error deleting these Teams(s)',
                alertProps: { severity: 'warning' },
              });
              break;
            }
          }
        }
        handleClose();
        setRefetchToggleForBusinessTeams({});
        enqueueSnackbarWithStyles({
          message: `Successfully Deleted ${values.selected.length} Team(s)`,
          alertProps: { severity: 'success' },
        });
        actions.resetForm({});
      }}
      enableReinitialize={true}
      initialValues={{
        selected: selected ?? [],
      }}
    >
      {(formik) => (
        <>
          <form
            className="form form-label-right"
            onSubmit={formik.handleSubmit}
            noValidate
          >
            <ModalWithStyles
              onSubmit={formik.handleSubmit}
              title="Delete Team(s)"
              aria-labelledby="example-modal-sizes-title-md"
              show={show}
              onHide={handleClose}
              isSubmitting={formik.isSubmitting}
              isLoading={formik.isSubmitting}
              deleteDialog={true}
              size="xs"
            >
              <p>
                You are about to delete {formik.values.selected.length} selected
                Team(s), this procedure is not reversible.
              </p>
              <p>Do you want to proceed?</p>
            </ModalWithStyles>
          </form>
        </>
      )}
    </Formik>
  );
}
